import { Controller } from 'stimulus';
import loadCss from '../helpers/loadCss';
import toArray from '../helpers/toArray';
import csrfToken from '../helpers/csrfToken';

class Gist extends Controller {
  connect() {
    Gist.loadHighlight().then(({ default: hljs }) => {
      this.hljs = hljs;

      const theme = document.body.className.indexOf('is-dark-mode') >= 0 ? 'dark' : 'light';

      Gist.loadHighlightCSS(theme).then(() => {
        Gist.loadGist(this.data.get('url')).then((code) => {
          if (typeof code.files === 'undefined') {
            return;
          }

          this.renderCode(code);
        });
      });
    });
  }

  renderCode(code) {
    this.element.innerHTML = '';

    Object.keys(code.files).forEach((fileName) => {
      const file = code.files[fileName];
      const codeHTML = Gist.renderCodeBlock(file);
      const actionsHTML = Gist.renderCodeActions(file);

      const block = document.createElement('div');

      block.innerHTML = `
        ${codeHTML}
        ${actionsHTML}
      `;

      this.element.appendChild(block);
    });

    toArray(this.element.querySelectorAll('code')).forEach((codeElement) => {
      this.hljs.highlightElement(codeElement);
    });
  }

  static renderCodeBlock(file) {
    return `
      <div>
        <pre><code class="primary-language language-${file.language}">${file.content}</code></pre>
      </div>
    `;
  }

  static renderCodeActions(file) {
    return `
      <div class="gistActions">
        <a
            href="${file.raw_url}"
            target="_blank"
            rel="nofollow noreferrer"
            class="btn btn--primary-light"
        >
          View RAW Code
        </a>
      </div>
    `;
  }

  static loadHighlight() {
    return import(/* webpackChunkName: "highlight" */ '../highlight');
  }

  static loadHighlightCSS(theme) {
    const file = theme === 'dark' ? 'highlight-dracula.css' : 'highlight-docco.css';

    return loadCss(`/front_assets/${file}`);
  }

  static loadGist(url) {
    return new Promise((resolve) => {
      fetch('/nl/api/gist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': csrfToken(),
        },
        body: JSON.stringify({ url }),
      })
        .then((res) => res.json())
        .then((res) => {
          resolve(res);
        });
    });
  }
}

Gist.targets = [
  //
];

export default Gist;
